import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getBounds } from '@/util/bounds.js';

import FancyField from '@/components/FancyField/FancyField';
import Button from '@material-ui/core/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink as LinkIcon } from '@fortawesome/pro-regular-svg-icons';

import styles from '@/components/Resize/Resize.module.css';

import { setAspectLock } from '@/action/tools';

const actions = {
    setAspectLock
};

/** ResizeOverlay component description */
class ResizeOverlay extends Component {
    constructor(props) {
        super(props);

        this.xxx = props.xxx;

        this.toggleAspectLock = this.toggleAspectLock.bind(this);
    }

    toggleAspectLock() {
        console.log('toggle aspect', this.props.aspectLock);


        this.props.setAspectLock(
            !this.props.aspectLock
        )
    }

    render() {
        let bounds = {};
        if (this.props.content.selection.length > 0) {
            bounds = getBounds(this.props.media, this.props.content.selection);
        } else {
            return null;
        }

        let self = this;

        // console.log(this.state.lockActive);

        return (<div className={styles.ResizeOverlay}>
            <FancyField label="W" value={Math.round(bounds.maxX - bounds.minX)} />
            <Button
                aria-label="Lock Aspect Ratio"
                className="clickable"
                variant='outlined'
                classes={{ 
                    root: styles.button, 
                    outlined: self.props.aspectLock ? styles.on : styles.off , 
                    focusVisible: styles.buttonFocus }}
                disableFocusRipple
                // action={wtf}
                
                onClick={(e) => self.toggleAspectLock(e) }
            >
                {/* <FontAwesomeIcon
                    icon={["far", "link"]}
                /> */}
                <FontAwesomeIcon
                    icon={ LinkIcon }
                />
                {/* <SvgIcon><LinkIcon /></SvgIcon> */}
            </Button>
            <FancyField label="H" value={Math.round(bounds.maxY - bounds.minY)} />
        </div>);
    }
}

ResizeOverlay.defaultProps = {
    active: true
};

const mapStateToProps = (state, ownProps) => {
    return {
        content: state.content,
        media: state.content.media, //getMediaSelector(state), // state.content.media, //
        aspectLock: state.tool.aspectLock
    }
    // return Object.assign({}, { z: state.xxx }, ownProps);
}

ResizeOverlay.displayName = "ResizeOverlayComponent";
const connectedComponent = connect(
    mapStateToProps,
    {
        ...actions
    }
)(ResizeOverlay);
connectedComponent.displayName = "ResizeOverlay";


ResizeOverlay.propTypes = {

};

export default connectedComponent;
export { ResizeOverlay as ResizeOverlayComponent };